import React from 'react'
import { Typography } from '@mui/material'
import useStore from 'stores/utils/hooks/useStore'
import { useText } from 'stores/utils/hooks/useText'
import TextLink from './TextLink'

export const LegalText = () => {
  const clientDetails = useStore(
    (store) => store.clientDetailsStore?.clientDetails
  )
  const {
    text: { copy }
  } = useText()

  return (
    <Typography variant="caption">
      {copy?.dac}{' '}
      <TextLink link={clientDetails?.urls.dataProtection}>
        Weitere Informationen
      </TextLink>
      .
    </Typography>
  )
}
